import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/sapi/v4/payment/fiat/";

/** 获取法币列表（按余额排序），用于与 fiatCurrencyIds、IP 合并得到允许展示的法币（与 ssr-web-index 一致） */
export function getFiatListByBalance(config?: any) {
  return XtAxios4.get(URL + "list/by-balance", config);
}
